import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

// SERVICES START
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
// SERVICES END

@Component({
  selector: 'app-requested-eois',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './requested-eois.component.html',
  styleUrl: './requested-eois.component.css',
})
export class RequestedEoisComponent implements OnInit {
  projectEoiRequests!: any;
  projectId!: number;
  projectName: string;
  projectIdentifier: string;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private tenderingService: TenderingService
  ) {}
  ngOnInit(): void {
    this.getProjectEOIs();
    this.activatedRoute.paramMap.subscribe((params) => {
      // NOTE: projectId matches param in routes file
      this.projectId = parseInt(params.get('projectId'));
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.projectIdentifier = params['projectIdentifier'];
      this.projectName = params['projectName'];
    });
  }

  getProjectEOIs(): any {
    return this.tenderingService.getProjectEOIListing().subscribe({
      next: (response: any) => {
        this.projectEoiRequests = response.data;
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ('0' + date.getDate()).slice(-2); // Add leading zero

    return `${year}-${month}-${day}`;
  }

  openIndividualEOIView(id: any) {
    if (this.projectId) {
      this.router.navigate(['/eoi-request-detail', this.projectId, id], {
        state: {
          eoiId: id,
          projectId: this.projectId,
          tenderingSubType: 'eoi',
        },
        queryParams:{
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier
        }
      });
    }
  }
}
